
import { createUser, signIn } from "@/store/db";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class RegisterView extends Vue {
  email = "";
  password = "";
  displayName = "";
  register() {
    if (this.email && this.password) {
      createUser(this.email, this.password, this.displayName);
      this.email = "";
      this.password = "";
    }
  }
}
